export enum WhoopRole {
  COMMUNITY_ADMIN = 'community_admin',
  ENTERPRISE_ADMIN = 'enterprise_admin',
  ENTERPRISE_WORKSPACE_MANAGER = 'enterprise_workspace_manager',
  ENTERPRISE_COHORT_MANAGER = 'enterprise_cohort_manager',
}

export default WhoopRole;
